'use strict';

var angular = require('angular');
var _ = require('lodash');
var toastr = require('toastr');
var StrategyClosureController = function StrategyClosureController($scope, strategyClosureActionService, conditionsAndActionsService, transformerService, saveStrategyService, strategyConstants, StrategyCondition, elementServiceProvider, momentService, validation, commonUiConstants) {
  var NEW_CLOSURE_STRATEGY = 'New Closure Strategy';
  var OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = '';
  var flightLegClassCondition = conditionsAndActionsService.getConditionByDomain(strategyConstants.CLASS_CLOSURE.LEVEL, $scope.activeEntityType);
  function determinePanelTitle() {
    return $scope.strategy.old ? $scope.strategy.name : NEW_CLOSURE_STRATEGY;
  }
  $scope.summaryMessage = strategyConstants.ERROR_MESSAGES.MULTIPLE;
  $scope.level = flightLegClassCondition.label;
  $scope.domain = flightLegClassCondition.domain;
  $scope.flightLegClassConditionCategories = flightLegClassCondition.categories;
  $scope.panelTitle = determinePanelTitle();
  $scope.STRATEGY_NAME_PATTERN = commonUiConstants.ALPHA_NUMERIC_WITH_SOME_EXTRA_CHARS;
  $scope.strategyNameMsg = 'Strategy name contains invalid characters. Only alphanumeric characters and -, _, <, >, = are allowed.';
  $scope.elementService = elementServiceProvider.getInstance({
    createNewElement: function createNewElement() {
      return new StrategyCondition({});
    },
    getCollection: function getCollection() {
      return $scope.strategy && $scope.strategy.commonConditions;
    },
    getSelectedRowType: function getSelectedRowType() {
      return strategyConstants.CONDITION;
    },
    isDuplicable: function isDuplicable() {
      return true;
    },
    createCopyOf: function createCopyOf(element) {
      if (element instanceof StrategyCondition) {
        return element.createCopy();
      }
      return null;
    }
  });
  function verifyConditionsExist() {
    var common = $scope.strategy.commonConditions;
    if (!common || !common.length) {
      var newElement = $scope.elementService.createNewElement();
      $scope.strategy.commonConditions = [newElement];
      $scope.elementService.selectElement(newElement);
    }
  }
  $scope.getCommonConditions = function () {
    return $scope.strategy.commonConditions;
  };
  $scope.resetIfEmpty = function () {
    if (isEmptyClosureStrategy()) {
      resetModel();
    } else if ($scope.strategy.basis === strategyConstants.StrategyType.CLASS_CLOSURE) {
      verifyConditionsExist();
    }
  };
  function isEmptyClosureStrategy() {
    // this should be rewritten - it's very error-prone
    return _.difference(Object.keys($scope.strategy), ['basis', 'public', 'type']).length === 0 && $scope.strategy.basis === strategyConstants.StrategyType.CLASS_CLOSURE;
  }
  function resetModel() {
    verifyConditionsExist();
    $scope.strategy.actionList = strategyClosureActionService.getActionList();
  }
  function hasAllActionsEmpty() {
    return _.every($scope.strategy.actionList, validation.isCriteriaEmpty);
  }
  function hasOperandDataQuantityOverThreshold() {
    var criteriaOverThreshold = validation.filterCriteriaOverThreshold($scope.strategy.commonConditions);
    if (criteriaOverThreshold.length > 0) {
      var criteriaNames = validation.getCriteriaNamesForMessage(criteriaOverThreshold);
      OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE = strategyConstants.ERROR_MESSAGES.OPERAND_DATA_OVER_THRESHOLD + criteriaNames;
      return true;
    }
    return false;
  }
  $scope.resetIfEmpty();
  $scope.isRowSelected = $scope.elementService.isElementSelected;
  $scope.changeSelectedRow = $scope.elementService.selectElement;
  $scope.conditionsAccordionSelect = function (conditionCategory, conditionCriteria) {
    $scope.elementService.insertElement(new StrategyCondition({
      quantifier: 'AND',
      category: conditionCategory.categoryName,
      criterion: conditionCriteria.criteriaName,
      field: conditionCriteria.field,
      operator: conditionCriteria.operators[0].operator,
      precision: conditionCriteria.operators[0].precision,
      isFieldValueRequired: !_.isUndefined(conditionCategory.isFieldValueRequired) ? conditionCategory.isFieldValueRequired : true
    }));
  };
  function showSummaryMessage(message) {
    $scope.isSummaryVisible = true;
    $scope.summaryMessage = message;
    if ($scope.focusErrorMsg) {
      $scope.focusErrorMsg();
    }
  }
  $scope.saveButtonHandler = function () {
    $scope.isSummaryVisible = false;
    $scope.xtForm.submit();
    var duplicated;
    if (hasAllActionsEmpty()) {
      return showSummaryMessage(strategyConstants.ERROR_MESSAGES.MISSING_ACTIONS);
    } else if (hasOperandDataQuantityOverThreshold()) {
      return showSummaryMessage(OPERAND_DATA_OVER_THRESHOLD_ERROR_MESSAGE);
    } else if ((duplicated = validation.collectDuplicatedConditions($scope.strategy.commonConditions)) && duplicated.length) {
      return showSummaryMessage(strategyConstants.ERROR_MESSAGES.STRATEGY_DUPLICATES + duplicated.join(', '));
    }
    if ($scope.xtForm.form.$invalid) {
      $scope.isSummaryVisible = _.get($scope, 'xtForm.form.$error.required.length') || false;
      if ($scope.isSummaryVisible) {
        $scope.summaryMessage = strategyConstants.ERROR_MESSAGES.MULTIPLE;
      }
      if ($scope.focusErrorMsg) {
        $scope.focusErrorMsg();
      }
      return;
    }
    var oldObj = _.extend({}, $scope.strategy.old);
    var newObj = _.extend({}, $scope.strategy);
    newObj.old = undefined;
    oldObj.old = undefined;
    if (!_.isEqual(oldObj, newObj) && $scope.strategy.usage > 0) {
      angular.element('#edit-closure-confirm-modal').modal();
    } else {
      $scope.strategySaveConfirm();
    }
  };
  function clearModalElements() {
    angular.element('#edit-closure-confirm-modal').modal();
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  }
  function closeAction() {
    clearModalElements();
    resetModel();
    $scope.hideSummary();
    $scope.xtForm.reset();
    $scope.closeHandler();
  }
  $scope.strategySaveConfirm = function (newName) {
    var transformedPayload = transformerService.transform($scope.strategy, $scope.getCommonConditions());
    var createdAt = momentService.now(momentService.FIELD.CREATED_AT);
    var createdDate = momentService.copy(createdAt, momentService.FIELD.CREATED_DATE);
    if (newName) {
      transformedPayload.strategy.name = newName;
      transformedPayload.strategy.createdAt = createdAt;
      transformedPayload.strategy.createdDate = createdDate;
      transformedPayload.strategy.technicalId = undefined;
      transformedPayload.strategy.usage = 0;
    }
    saveStrategyService.saveStrategy(transformedPayload.strategy, strategyConstants.CLASS_CLOSURE.LEVEL, transformedPayload.commonConditions).then(function () {
      $scope.$emit('strategy:dataAndSelectionChanged', {
        name: newName ? newName : $scope.strategy.name
      });
      closeAction();
      toastr.success('Successfully saved changes.');
    }, function (reason) {
      $scope.isSummaryVisible = true;
      var reasonStr = reason.data ? ' (' + reason.data.message + ')' : '';
      $scope.summaryMessage = strategyConstants.ERROR_MESSAGES.SAVING + reasonStr;
    });
  };
  $scope.cancelButtonHandler = function () {
    closeAction();
  };
  $scope.isSummaryVisible = false;
  $scope.hideSummary = function () {
    $scope.isSummaryVisible = false;
  };
  $scope.isStatementBoxVisible = false;
  $scope.toggleStatementBox = function () {
    $scope.isStatementBoxVisible = !$scope.isStatementBoxVisible;
  };
};
StrategyClosureController.$inject = ['$scope', 'StrategyClosureActionService', 'ConditionsAndActionsService', 'ModelToPayloadTransformerService', 'SaveStrategyService', 'StrategyConstants', 'StrategyConditionFactory', 'ElementServiceProvider', 'MomentService', 'CriteriaValidateAndFilterService', 'CommonUiConstants'];
module.exports = StrategyClosureController;